import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api/useGetQuery";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { type Shift, shiftSchema } from "@src/appV2/Shifts/Shift/types";
import { z } from "zod";

const upcomingShiftsGroupedResponseSchema = z.object({
  response: z.record(z.string(), shiftSchema),
});

type UpcomingShiftsGroupedResponse = z.infer<typeof upcomingShiftsGroupedResponseSchema>;

export type ShiftsByFacility = Record<string, Shift>;

export const GET_UPCOMING_SHIFTS_GROUPED_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/v1/shifts/upcomingShiftsGrouped`;

export function useGetUpcomingShiftsGrouped(
  options: UseGetQueryOptions<UpcomingShiftsGroupedResponse> = {}
) {
  return useGetQuery({
    url: GET_UPCOMING_SHIFTS_GROUPED_URL,
    responseSchema: upcomingShiftsGroupedResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_UPCOMING_SHIFTS_FAILURE,
    },
    ...options,
  });
}
